const weekTReducer = (state = [], {type, load}) => {
    switch (type) {
        case 'GET_WEEKLY': if(state.length < 1) {
            return [...state, ...load]
         } else return state
            
         
        default: return state
            
    }
}

export default weekTReducer